/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Nav_CompareInputs */

const en_cad_nav_compare = /** @type {(inputs: Cad_Nav_CompareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vs AutoCAD`)
};

/**
* | output |
* | --- |
* | "vs AutoCAD" |
*
* @param {Cad_Nav_CompareInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_nav_compare = /** @type {((inputs?: Cad_Nav_CompareInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Nav_CompareInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_nav_compare(inputs)
});
export { cad_nav_compare as "cad.nav.compare" }